// extras stream: lead source, WhatsApp, households, after-hours.
export const en: Record<string, string> = {
  "extras.leadSource": "Lead source",
  "extras.whatsapp": "Prefers WhatsApp on this number",
  "extras.household": "Household",
  "extras.household.hint": "Family members, co-insureds and drivers with their own files. They show on each other's file.",
  "extras.household.none": "Not linked to anyone yet.",
  "extras.household.add": "Link a person",
  "extras.household.search": "Search by name or phone",
  "extras.household.link": "Link",
  "extras.household.unlink": "Remove from household",
  "extras.household.linked": "Household updated",
  "extras.household.policies": "{n} active policies",
  "extras.afterHours": "After-hours replies",
  "extras.afterHours.sub": "Outside office hours, inbound texts get a short automatic reply from the assistant (policy status, how to pay, ID card requests acknowledged) and still open a task. Needs the assistant turned on.",
  "extras.afterHours.open": "Open",
  "extras.afterHours.close": "Close",
  "reports.lead_sources": "Lead sources",
};

export const es: Record<string, string> = {
  "extras.leadSource": "Origen del cliente",
  "extras.whatsapp": "Prefiere WhatsApp en este número",
  "extras.household": "Hogar",
  "extras.household.hint": "Familiares, coasegurados y conductores con expediente propio. Aparecen en el expediente de cada uno.",
  "extras.household.none": "Todavía no está vinculado con nadie.",
  "extras.household.add": "Vincular persona",
  "extras.household.search": "Buscar por nombre o teléfono",
  "extras.household.link": "Vincular",
  "extras.household.unlink": "Quitar del hogar",
  "extras.household.linked": "Hogar actualizado",
  "extras.household.policies": "{n} pólizas activas",
  "extras.afterHours": "Respuestas fuera de horario",
  "extras.afterHours.sub": "Fuera del horario de oficina, los mensajes entrantes reciben una respuesta automática breve del asistente (estado de póliza, cómo pagar, tarjeta de seguro en camino) y además abren una tarea. Requiere el asistente activado.",
  "extras.afterHours.open": "Abre",
  "extras.afterHours.close": "Cierra",
  "reports.lead_sources": "Origen de clientes",
};
